import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { ReactElement } from 'react';

interface CommonDialogProps {
  children: ReactElement;
  open: boolean;
  onClose: () => void;
  title: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  disableBackdropClick?: boolean;
}

export default function CommonDialog(
  { children,
    open,
    onClose,
    title,
    size,
    disableBackdropClick = false,
  }: CommonDialogProps) {

  const handleClose = (_event: object, reason: string) => {
    if ((disableBackdropClick && reason === "backdropClick") || reason === "escapeKeyDown") {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        zIndex: 9999,
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(0.625rem)',
          WebkitBackdropFilter: 'blur(0.625rem)',
        },
      }}
      maxWidth={size}
    >
      <DialogTitle fontWeight={700}>{title}</DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
    </Dialog>
  );
}
